import { render, staticRenderFns } from "./order-details.vue?vue&type=template&id=7064e12e&scoped=true"
import script from "./order-details.vue?vue&type=script&lang=ts"
export * from "./order-details.vue?vue&type=script&lang=ts"
import style0 from "./order-details.vue?vue&type=style&index=0&id=7064e12e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7064e12e",
  null
  
)

export default component.exports